'use-client';
import ShareButtons from '../../ShareButtons';

export default ShareButtons;
